import type { IExceptionAPIClient } from "./types";
import "vue-toastification/dist/index.css";
import { useToast } from "vue-toastification";

export default class ToastificationNotificationException
  implements IExceptionAPIClient
{
  handle(error: string): void {
    const toast = useToast();

    toast.error(error);
  }
}
